import * as React from 'react';
import { createContext, useContext, useMemo } from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';

export type CoachCareerFitAssistantExperimentContextType = {
  showCoachCareerFitAssistantInsideProductOverview: boolean;
  showCoachCareerFitAssistantInsideHero: boolean;
  coachCareerFitAssistantEnabled: boolean;
};

export const CoachCareerFitAssistantExperimentContext = createContext<CoachCareerFitAssistantExperimentContextType>({
  showCoachCareerFitAssistantInsideProductOverview: false,
  showCoachCareerFitAssistantInsideHero: false,
  coachCareerFitAssistantEnabled: false,
});

function CoachCareerFitAssistantExperimentProvider({ children }: React.PropsWithChildren) {
  const isAuthenticated = isAuthenticatedUser();
  const coachCareerFitAssistantOnXdp = useMemo(
    () => (isAuthenticated ? GrowthDiscoveryEpicClient.get('coachCareerFitAssistantOnXdp') : 'control'),
    [isAuthenticated]
  );
  const showCoachCareerFitAssistantInsideProductOverview = coachCareerFitAssistantOnXdp === 'B';
  const showCoachCareerFitAssistantInsideHero = coachCareerFitAssistantOnXdp === 'C';
  const coachCareerFitAssistantEnabled = coachCareerFitAssistantOnXdp === 'B' || coachCareerFitAssistantOnXdp === 'C';

  return (
    <CoachCareerFitAssistantExperimentContext.Provider
      value={{
        showCoachCareerFitAssistantInsideProductOverview,
        showCoachCareerFitAssistantInsideHero,
        coachCareerFitAssistantEnabled,
      }}
    >
      {coachCareerFitAssistantEnabled ? <CoachStateProvider>{children}</CoachStateProvider> : children}
    </CoachCareerFitAssistantExperimentContext.Provider>
  );
}

export const useCoachCareerFitAssistantExperimentData = () => {
  return useContext(CoachCareerFitAssistantExperimentContext);
};

export default CoachCareerFitAssistantExperimentProvider;
